<template>
  <div class="tech btn" @click="btnTechHandler"></div>
</template>
<script>
export default {
  name: 'tech',
  methods: {
    btnTechHandler() {
      window.location.href = 'https://www.foshannews.net/';
    },
  },
};
</script>
<style lang="scss" scoped>
.tech {
  position: absolute;
  z-index: 8;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  bottom: 1rem;
  @include w(226);
  @include h(32);
  @include bg("tech.png");
}
</style>
